import store from '../../../../../../../store';
import {addChangeValuePopup, changeValuePopup, deleteChangeValuePopup} from '../../../../../../../actions/sqftMenuFunctions';
import ChangeValuePopup from '../../../../popup/models/ChangeValuePopup';

// Use the calculator's existing angle popup, while the canvas label stays a NumberText.
export function openFreeFormAnglePopup(id, value, position, applyValue, onClose) {
  let isClosed = false;
  let appliedValue = value;
  const close = () => {
    if (isClosed) {
      return;
    }
    isClosed = true;
    store.dispatch(deleteChangeValuePopup(id));
    onClose();
  };
  const getPopup = () => store.getState().sqftMenuState.changeValuePopups.find(popup => popup.id === id);
  const updateValue = nextValue => {
    const popup = getPopup();
    if (!popup) {
      return;
    }
    if (!/^\d*(?:[.,]\d*)?$/.test(String(nextValue))) {
      return;
    }
    store.dispatch(changeValuePopup({...popup, value: nextValue, inputError: null}));
  };
  const applyDegrees = degrees => {
    const popup = getPopup();
    if (!popup) {
      return false;
    }
    const roundedDegrees = Math.round(degrees * 10) / 10;
    if (!Number.isFinite(degrees) || degrees < 0 || degrees > 171 || !applyValue(roundedDegrees)) {
      store.dispatch(changeValuePopup({...popup, value: appliedValue,
        inputError: 'This angle cannot be applied. The current angle has been restored.'}));
      return false;
    }
    appliedValue = roundedDegrees;
    store.dispatch(changeValuePopup({...popup, value: appliedValue, inputError: null}));
    return true;
  };
  const confirm = () => {
    const popup = getPopup();
    const text = String(popup?.value ?? '').trim();
    const degrees = text === '' ? NaN : Number(text.replace(',', '.'));
    if (applyDegrees(degrees)) {
      close();
    }
  };
  const step = delta => {
    const popup = getPopup();
    const current = Number(String(popup?.value).replace(',', '.'));
    if (Number.isFinite(current)) {
      applyDegrees(Math.max(0, Math.min(171, Math.round((current + delta) * 10) / 10)));
    }
  };
  const popup = new ChangeValuePopup(id, 0, 171, confirm,
    () => step(1), () => step(-1), event => updateValue(event.target.value),
    value, position, '', false, true);
  popup.onKeyDown = event => {
    event.stopPropagation();
    if (event.key === 'Enter') {
      event.preventDefault();
      confirm();
    } else if (event.key === 'Escape') {
      event.preventDefault();
      close();
    }
  };
  store.dispatch(addChangeValuePopup(popup));
  return {close};
}
